import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PhotographyApiService } from './api.service';
import { PhotographyListResponse } from '../models/photography-vendor.model';
import { PhotographyZipCodeDetails } from '../models/photography-catalog.model';

/** Narrows a zip code search. State is required by the Zip Finder; city and county are exact matches. */
export interface PhotographyZipCodeSearch {
  state: string;
  city?: string;
  county?: string;
}

/** The largest page lcms-photography allows for a filtered search; the biggest state has about 2,600 zips */
export const MAX_ZIP_SEARCH = 5000;

/** Looks up zip codes in the lcms-photography reference data, for finding zips to add to a region */
@Injectable({
  providedIn: 'root',
})
export class PhotographyZipCodeService {
  private api = inject(PhotographyApiService);

  readonly resource = 'zip-codes';

  states$(): Observable<string[]> {
    return this.api.get<{ items: string[] }>(`${this.resource}/states`).pipe(map((response) => response.items));
  }

  /** The cities and counties in a state */
  places$(state: string): Observable<{ cities: string[]; counties: string[] }> {
    return this.api.get<{ cities: string[]; counties: string[] }>(`${this.resource}/places`, { state });
  }

  search$({ state, city, county }: PhotographyZipCodeSearch): Observable<PhotographyZipCodeDetails[]> {
    const params = { state, city, county, limit: MAX_ZIP_SEARCH };
    return this.api.get<PhotographyListResponse<PhotographyZipCodeDetails>>(this.resource, params).pipe(
      map((response) => response.items),
    );
  }
}
